// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"bc28d989","407":"b9441318"}[chunkId] + ".chunk.js";
};